export default __webpack_public_path__ + "static/media/p-1-mobile.dac8ce70.png";